module.exports = __webpack_public_path__ + "img/question_hover.dfba3737.png";